import request from '@/utils/request.js'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
const prefix = process.env.VUE_APP_API_PREFIX || '/api/dataAtlas/v1'

// 一体化2.0登录
export function XZHLogin(data) {
  return request({
    url: '/ourchem-integration/auth?tenantId=' + data.tenantId,
    method: 'POST',
    data
  })
}

// 专利转化价值分布
export function getValueRange() {
  return request({
    url: `${prefix}/value_range`,
    method: 'POST'
  })
}
// 专利运营转化
export function getTransferRange() {
  return request({
    url: `${prefix}/transfer_range`,
    method: 'POST'
  })
}
// 新增专利统计
export function patentIncrease() {
  return request({
    url: `${prefix}/patent_increase`,
    method: 'POST'
  })
}

// PCT专利统计
export function getValuePCT() {
  return request({
    url: `${prefix}/pct_range`,
    method: 'POST'
  })
}
// 申请人合作
export function getValueCooperate(data) {
  return request({
    url: `${prefix}/cooperate_range`,
    method: 'POST',
    data
  })
}
// 专利奖
export function legalRange(data) {
  return request({
    url: `${prefix}/legal_range`,
    method: 'POST',
    data
  })
}
// 数量
export function perIncrease(data) {
  return request({
    url: `${prefix}/per_increase`,
    method: 'POST',
    data
  })
}
export function yearRange() {
  return request({
    url: `${prefix}/year_range`,
    method: 'POST'
  })
}

// 登录
export function login(params, data) {
  const url = handlerGetUrlParams('/auth', params)
  return request({
    url,
    method: 'POST',
    data
  })
}

export function getPatentAll() {
  return request({
    url: `${prefix}/top_org`,
    method: 'POST'
  })
}

export function getInventor() {
  return request({
    url: `${prefix}/inventor_range`,
    method: 'POST'
  })
}

export function getAbbreviation() {
  return request({
    url: `${prefix}/abbr`,
    method: 'get'
  })
}
export function getWorthRange() {
  return request({
    url: '/ourchem-integration/system/classify/worth_range',
    method: 'get'
  })
}
export function getTenantByCode(code) {
  return request({
    url: '/ourchem-integration/system/tenantManage/getTenantByCode?code=' + code,
    method: 'get'
  })
}
export function isClassify() {
  return request({
    url: '/ourchem-integration/platform/exist/classify',
    method: 'get'
  })
}
export function rewardRange() {
  return request({
    url: '/ourchem-integration/digitalScreen/reward_range',
    method: 'post'
  })
}

export function ipcsecRange() {
  return request({
    url: '/ourchem-integration/digitalScreen/ipcsec_range',
    method: 'post'
  })
}

export function seiRange() {
  return request({
    url: '/ourchem-integration/digitalScreen/sei_range',
    method: 'post'
  })
}

export function agencyRange() {
  return request({
    url: '/ourchem-integration/digitalScreen/agency_range',
    method: 'post'
  })
}

export function assigneesNormalRange() {
  return request({
    url: '/ourchem-integration/digitalScreen/assignees_normal_range',
    method: 'post'
  })
}
